import {viewSuccess} from 'src/pages/scheduleCallback/store/selectors/channelTracking';
import {CREATE_INTERACTION_SUCCESS} from 'src/pages/scheduleCallback/store/actions/interactions';

export const transferred = {
  [CREATE_INTERACTION_SUCCESS]: viewSuccess,
};
